import createDataContext from "./createDataContext";
import { getDate, isPast } from "date-fns";


var axios = require("axios");
var _ = require("lodash");
var qs = require("qs");

const reducer = (state, action) => {
  switch (action.type) {
    case "update_deals":
      if (state.deals !== action.payload) {
        return {
          ...state,
          deals: action.payload.deals,
          selectedDeal: action.payload.selectedDeal,
        };
      } else {
        return;
      }
    case "set_autopay_modal_open":
      return {
        ...state,
        autoPayModalOpen: action.payload,
      };
    case "update_autoPay":
      console.log(action)
      return {
        ...state,
        autoPay: {
          ...action.payload,
          autoPayEnabled: action.payload.autoPayEnabled === 0 ? false : true,
        },
        autoPayModalOpen: false,
      };
    case "enable_autopay":
      return {
        ...state,
        autoPay: {
          ...state.autoPay,
          autoPayEnabled: action.payload,
        },
        autoPayModalOpen: false,
      };
    case "set_selected_deal":
      return {
        ...state,
        selectedDeal: action.payload.selectedDeal,
      };
    default:
      return state;
  }
};

const getAutoPay = (dispatch) => async () => {
  try {
    axios({
      method: "post",
      data: qs.stringify({
        method: "getAutoPay",
      }),
      withCredentials: true,
    }).then((response) => {
      //console.log("Auto Pay", response.data);

      dispatch({
        type: "update_autoPay",
        payload: response.data,
      });
    });
  } catch {
    console.log("ERrrrrror getting auto pay");
  }
};

const updateAutoPay = (dispatch) => async (
  { paymentMethod, 
    state, 
    autopay_reminder_days = '', 
    autopay_pay_advance_days = '', 
    autopay_pay_day_of_month = '', 
    autopay_max_amount = '', 
    autopay_amount_override = '',
    autopay_start_date = ''
  }) => {
  //console.log(paymentMethod);
  dispatch({
    type: "enable_autopay",
    payload: state === "off" ? 0 : 1,
  });



  try {
    axios({
      method: "post",
      data: qs.stringify({
        method: "updateAutoPay",
        paymentMethod,
        state,
        autopay_reminder_days,
        autopay_pay_advance_days,
        autopay_pay_day_of_month,
        autopay_max_amount,
        autopay_amount_override,
        autopay_start_date
      }),
      withCredentials: true,
    }).then((response) => {
      //console.log("UPDATE Auto Pay", response.data);

      if (response.data.status === 1) {
        axios({
          method: "post",
          data: qs.stringify({
            method: "getAutoPay",
          }),
          withCredentials: true,
        }).then((response) => {
          //console.log("Auto Pay", response.data);

          dispatch({
            type: "update_autoPay",
            payload: response.data,
          });
        });
      } else {
        dispatch({
          type: "enable_autopay",
          payload: state === "off" ? 1 : 0,
        });
      }
    });
  } catch {
    console.log("ERrrrrror updating auto pay");
  }
};

const setAutoPayModalOpen = (dispatch) => async (bool) => {
  dispatch({ type: "set_autopay_modal_open", payload: bool });
};

const getDeals = (dispatch, history) => async () => {
    try{
      const response = await axios({
          method: "post",
          data: qs.stringify({
            method: "getDeals",
          }),
          withCredentials: true,
        });


      if (response.data.status === 0) {
        sessionStorage.remove("authenticated");
      }
      let dealsResponse = response.data.deals;

      dispatch({
        type: "update_deals",
        payload: {
          deals: dealsResponse,
          selectedDeal: dealsResponse[0],
        },
      });
    } catch {
      console.log("ERrrrrror getting Deals");
    }

    

};


const setSelectedDeal = (dispatch, history) => async (deal) => {
    try{
      dispatch({
        type: "set_selected_deal",
        payload: {
          selectedDeal: deal,
        },
      });

    } catch {
      console.log("ERrrrrror setting Deal");
    }
}




export const { Provider, Context } = createDataContext(
  reducer,
  {
    getDeals,
    setSelectedDeal,
    getAutoPay,
    updateAutoPay,
    setAutoPayModalOpen,
  },
  {
    deals: [],
    selectedDeal: {},
    autoPay: {
      autoPayEnabled: false,
      nextDueDate: null,
      paymentLastFour: null,
      paymentMethod: "",
      autoPaySettings : {
        autopay_reminder_days : "15",
        autopay_pay_advance_days : "",
        autopay_pay_day_of_month :"",
        autopay_max_amount : "",
        autopay_amount_override :"",
        autopay_start_date : "", 
      },
    },
    autoPayModalOpen: false,
  }
);
